// MUI theme for the staff-only MaterialReactTable views (dashboard,
// verifications, client groups, visibility).
// The hex values below mirror the :root tokens in client/src/css/tokens.css —
// MUI v5 stable cannot consume CSS variables, so they are duplicated here.
// These tables only render on staff routes, so the frozen client-facing
// .theme-identitycheck skin is unaffected.
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#0038cf",
      dark: "#002ba3",
    },
    error: {
      main: "#8b1a15",
    },
    warning: {
      main: "#8b4a10",
    },
    success: {
      main: "#0a6640",
    },
    info: {
      main: "#002ba3",
    },
    text: {
      primary: "#000000",
      secondary: "#4a5568",
      disabled: "#5a6072",
    },
    divider: "#E4E7EE",
    background: {
      default: "#f4f6fc",
      paper: "#ffffff",
    },
  },
  typography: {
    fontFamily: "Roboto, 'Source Sans Pro', sans-serif",
    button: {
      textTransform: "none",
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 10,
  },
  components: {
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          border: "1px solid #E4E7EE",
          boxShadow: "0 1px 2px rgba(20,30,60,0.04)",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontSize: 11,
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          color: "#5a6072",
          fontWeight: 500,
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&.MuiTableRow-hover:hover": {
            backgroundColor: "#f4f6fc",
          },
        },
      },
    },
  },
});

export default theme;
